export default "__VITE_ASSET__D1xfNBW7__"